import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {inject, observer} from 'mobx-react';
import {Link, withRouter} from 'react-router';
import autobind from 'autobind-decorator';

import { BOOKING_BASE_URL } from 'utils/constants';

import Button from '@urbanmassage/component-library/lib/Button/Button';

import AppsLinks from '../AppsLinks';
import SessionSplit from 'spa/Components/SessionSplit';

import Logo from './Logo';
import {withConfig, withI18n} from 'spa/Components/Context';

const isServer = typeof window === 'undefined';
const {HERO_BASE_URL} = isServer ? process.env : window;

@withRouter
@inject('store')
@observer
@withConfig
@withI18n
class PageMenu extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;

    this.communityUrl = config.getValue('b2c.community-url', i18n.umRegion);
    this.giftsEnabled = config.getValue('feature.gift-vouchers-enabled', i18n.umRegion);
  }

  @autobind
  @action('clickedCommunityLink - PageMenu')
  clickedCommunityLink(event) {
    const {tracker} = this.props.store;

    tracker.track('Clicked community link in the mobile menu', {
      category: 'Community site link',
    });
  }

  render() {
    const {giftsEnabled} = this;
    const {i18n} = this.context;

    return (
      <div className="page-menu" data-testid="page-menu-container">
        <div className="v-container">
          <div className="v-content v-content--expand">
            <Link to={`/${i18n.lc}/`} className="page-menu-item page-menu-item--logo" data-testid="page-menu-logo">
              <Logo />
            </Link>
            <ul>
              <li className="page-menu-item">
                <Link to={`/${i18n.lc}/treatments`} data-testid="page-menu-services-link">
                  {i18n._x('Treatments', 'page menu link')}
                </Link>
              </li>
              <li className="page-menu-item">
                <Link to={`/${i18n.lc}/therapists`} data-testid="page-menu-professionals-link">
                  {i18n._x('Practitioners', 'page menu link')}
                </Link>
              </li>
              <li className="page-menu-item">
                <Link to={`/${i18n.lc}/pricing`} data-testid="page-menu-pricing-link">
                  {i18n._x('Pricing', 'page menu link')}
                </Link>
              </li>
              <li className="page-menu-item">
                <Link
                  data-testid="page-menu-corporate-link"
                  href={
                    __DEV__ ?
                      `https://business.staging.urban.co/${i18n.lc}/?utm_referrer=www.urban.co` :
                      `https://business.urban.co/${i18n.lc}/?utm_referrer=www.urban.co`
                  }
                  target="_blank"
                >
                  {i18n._x('Corporate', 'page menu link')}
                </Link>
              </li>
              {giftsEnabled && <li className="page-menu-item"><Link to={`/${i18n.lc}/gifts`} data-testid="page-menu-gifts-link">{i18n._x('Gifts', 'page menu link')}</Link></li> }
              {i18n.lc === 'en-gb' ? (
                <li className="page-menu-item">
                  <a
                    href={this.communityUrl}
                    onClick={this.clickedCommunityLink}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Community
                  </a>
                </li>
              ) : null}
              <SessionSplit
                loggedIn={() => (
                  <li className="page-menu-item"><Link to={`/${i18n.lc}/account/bookings`} data-testid="page-menu-account-link">{i18n._x('Account', 'page menu link')}</Link></li>
                )}
                loggedOut={() => (
                  <li className="page-menu-item"><Link to={`/${i18n.lc}/login`} data-testid="page-menu-login-link">{i18n._x('Login', 'page menu link')}</Link></li>
                )}
              />
              <li
                className="page-menu-item page-menu-item--hero"
              >
                <a
                  data-testid="page-menu-hero-link"
                  href={`${HERO_BASE_URL}?utm_source=urban.co&utm_medium=website&utm_creative=header`}
                  target="_blank" // eslint-disable-line react/jsx-no-target-blank
                >
                  {i18n._x('Become an Urban pro', 'page menu link')}
                </a>
              </li>
            </ul>
            <AppsLinks className="page-menu-item page-menu-item--app-links" />
          </div>
          <div className="v-content">
            <div className="page-menu-item page-menu-item--booking" data-testid="page-menu-book-link">
              <Button
                href={`/${i18n.lc}/${BOOKING_BASE_URL}/`}
                notRounded
              >
                {i18n._x('Find Appointment', 'page menu link')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PageMenu;



// WEBPACK FOOTER //
// ./spa/Components/Header/PageMenu.jsx